import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup } from '@mui/material';
import apiClient from '../services/apiClient';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    // Optimistic: change UI immediately
    i18n.changeLanguage(lng);
    // Persist to backend (fire & forget)
    apiClient.patch('/api/users/me/language', { language: lng }).catch((err) => {
      console.warn('[LanguageSelector] Failed to persist language preference:', err.message);
    });
  };

  return (
    <ButtonGroup
      variant="outlined"
      aria-label="language selection buttons"
      size="small"
    >
      <Button
        onClick={() => changeLanguage('es')}
        disabled={i18n.resolvedLanguage === 'es'}
        sx={{ minWidth: '60px' }}
      >
        <span role="img" aria-label="Spanish flag" style={{ marginRight: '4px' }}>🇪🇸</span> ES
      </Button>
      <Button
        onClick={() => changeLanguage('en')}
        disabled={i18n.resolvedLanguage === 'en'}
        sx={{ minWidth: '60px' }}
      >
        <span role="img" aria-label="UK flag" style={{ marginRight: '4px' }}>🇬🇧</span> EN
      </Button>
    </ButtonGroup>
  );
};

export default LanguageSelector;
